var options = [
	{
		value: 0,
		label: '柔印机',
	},
	{
		value: 1,
		label: '胶印机',
	},
	{
		value: 2,
		label: '凹印机',
	},
	{
		value: 3,
		label: '热复合机',
	},
	{
		value: 4,
		label: '冷复合机',
	},
	{
		value: 5,
		label: '复卷机',
	},
	{
		value: 6,
		label: '其他',
	},
]

/**
 *
 * @param key
 */
var getName = (key: number) => {
	var name = ''
	if (key > -1) {
		var item = options.find(p => p.value == key)
		if (item) {
			name = item.label
		} else {
			console.warn(`设备类型：${key} 未找到.`)
		}
	}

	return name
}

export default {
	options,
	getName,
}
